module.exports = __webpack_public_path__ + "img/header-memoireRingsSignature@2x.6f7c0ed.jpg";